


































import { defineComponent, PropType, ref, watch, onMounted } from '@nuxtjs/composition-api';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppOptimizedImage from '~/components/partials/App/AppOptimizedImage.vue';
import { sendGaEvent, sendArticleEvent } from '~/utils/ga';
import { TopSlider } from '~/types/modules/top';
import type { SwiperOptions } from 'swiper';

export default defineComponent({
  components: {
    AppLink,
    AppOptimizedImage,
  },
  props: {
    items: {
      type: Array as PropType<TopSlider[]>,
      required: true,
    },
    // 読み物トップページかどうか
    isArticleTop: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const swiperWrapper = ref<HTMLDivElement>();
    const isMounted = ref(false);
    const isMouseHover = ref(false);
    const swiperOptions: SwiperOptions = {
      loop: true,
      loopAdditionalSlides: 1,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      initialSlide: 0,
      slidesPerView: 1,
      spaceBetween: 2,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index, className) {
          return `<div class="${className}"><div class="bullet"></div></div>`;
        },
      },
      navigation: {
        nextEl: '#top-carousel-next',
        prevEl: '#top-carousel-prev',
      },
      breakpoints: {
        767: {
          spaceBetween: 5,
        },
        // スライドが3つ以上表示されそうな解像度でクローンを増やす
        2000: {
          loopAdditionalSlides: 2,
        },
      },
      on: {
        realIndexChange(swiper) {
          emit('setActiveBannerIndex', swiper.realIndex);
        },
        slideChangeTransitionEnd(swiper) {
          if (!swiper.autoplay.running) {
            swiper.autoplay.start();
          }
        },
      },
    };

    const clickSlider = (url: string | undefined, title: string) => {
      if (props.isArticleTop) {
        sendArticleEvent('おどるわいん_スライダー枠', url, title);
      } else {
        sendGaEvent('スライダー枠', url, title);
      }
    };

    watch(swiperWrapper, (swiperWrapper, oldRef, onInvalidate) => {
      if (!process.client || !swiperWrapper) {
        return;
      }

      const onMouseEnter = () => {
        const swiperPaginationBulletActive = document.querySelector('.swiper-pagination-bullet-active');

        if (swiperPaginationBulletActive) {
          swiperPaginationBulletActive.classList.add('-no-animate');
        }
      };
      const onMouseLeave = () => {
        const swiperPaginationBulletActive = document.querySelector('.swiper-pagination-bullet-active');

        if (swiperPaginationBulletActive) {
          swiperPaginationBulletActive.classList.remove('-no-animate');
        }
      };

      swiperWrapper.addEventListener('mouseenter', onMouseEnter);
      swiperWrapper.addEventListener('mouseleave', onMouseLeave);

      onInvalidate(() => {
        swiperWrapper.removeEventListener('mouseenter', onMouseEnter);
        swiperWrapper.removeEventListener('mouseleave', onMouseLeave);
      });
    });

    onMounted(() => {
      isMounted.value = true;
    });

    return {
      AppLink,
      swiperWrapper,
      isMounted,
      isMouseHover,
      swiperOptions,
      clickSlider,
    };
  },
});
